<template>
  <div :id="containerId" :class="type">
    
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'src-components-echarts',
  components: {},
  props: {
    type: String,
    containerId: {
      required: true
    },
    data: {
      required: true
    },
    options: {
      required: false
    },
    clickEvent: {
      required: false
    },
    refreshToken: {
    },
    resize: {
    }
  },
  data () {
    let chartElement
    let ready = false
    return {
      chartElement,
      ready
    }
  },
  computed: {
    'allOptions': function () {
      return this.options
    }
  },
  beforeDestroy () {
    if (this.chartElement !== undefined) {
      this.chartElement.dispose()
    }
  },
  created () {
  },
  mounted () {
    
    window.addEventListener('resize', () => {
      if (this.containerId) {
        var htmlTarget = document.getElementById(this.containerId)
        if (htmlTarget) {
          let echartInstance = echarts.getInstanceByDom(htmlTarget)
          if (echartInstance) {
            if (htmlTarget !== null) {
                echartInstance.resize({
                width: htmlTarget.offsetWidth,
                height: htmlTarget.offsetHeight
              })
            }
          }
        }

        htmlTarget = null
      }
    })

    this.ready = true
  },
  methods: {
    clickE: function (e) {
      console.log(e)
      console.log(this.data[e.dataIndex])
      let params = this.$route.params
      console.log(params)
      params.tu = this.data[e.dataIndex][0]
      this.$router.replace({ name: this.$route.name, params: params, query: this.$route.query}).catch(()=>{})
    },
    /**
     * Creates the chart
     */
    drawChart () {
      // gets the div container
      let htmlTarget = document.getElementById(this.containerId)
      // initializes the chart and set the dimensions
      if (htmlTarget !== null) {
        this.chartElement = echarts.init(htmlTarget, null, {
          width: htmlTarget.offsetWidth,
          height: htmlTarget.offsetHeight
        })
      }
    },
    /**
     * Sets the chart options
     */
    setChartOptions () {
      if (this.chartElement && typeof this.allOptions === 'object' && this.allOptions.length !== 0) {
        this.chartElement.off('click')
        this.chartElement.on('click', this.clickE)
        // this.chartElement.on('click', this.options.event)
        // sets the chart options
        if (this.allOptions.regen === true) {
          this.chartElement.clear() // FIXME: verificare alternativa migliore
        }
        
        this.chartElement.setOption(this.allOptions)
      }
    },
  },
  watch: {
    'options' : function () {
      this.setChartOptions()
    },
    'ready': function () {
      this.drawChart()
      this.setChartOptions()
    },
    'refreshToken': function () {
      this.setChartOptions()
    },
    'resize': function () {
      this.chartElement.resize({
        width: 'auto'
      })
    },
    'height': function (newValue) {
      this.chartElement.resize({
        height: newValue,
        width: 'auto'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .chart {
    height: 58vh;
    width: 100%;
    border: 0px solid gray;
  }
  .chart_big {
    height: 66vh;
    width: 100%;
    border: 0px solid gray;
  }
  .chart_map {
    height: 54vh;
    width: 100%;
    border: 0px solid gray;
  }
.src-components-echarts {

}
</style>
